import { render } from "./Admin.vue?vue&type=template&id=66081a59&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=66081a59&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66081a59"]])

export default __exports__